import axiosInstance from "../axiosClient";

/**
 * Export activity logs to CSV
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @param {object} params - Export parameters (startDate, endDate, category, userId, entityType, entityId)
 * @returns {Blob} CSV file blob
 */
export const exportActivitiesCSV = async (token, orgUuid, params) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.category) queryParams.append('category', params.category);
    if (params.userId) queryParams.append('userId', params.userId);
    if (params.entityType) queryParams.append('entityType', params.entityType);
    if (params.entityId) queryParams.append('entityId', params.entityId);

    const response = await axiosInstance.get(
      `/organization/${orgUuid}/activities/export?${queryParams.toString()}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob' // Important for file download
      }
    );

    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'activity-logs.csv';


    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    } else {
    }

    return { blob: response.data, filename };
  } catch (error) {
    throw error;
  }
};
